import config from 'react-global-configuration';
import Immutable from 'immutable';
import { referenceLoadingStart, referenceLoadingDone } from '@uncinc/react-drupal-core';
import { webformGetInfoLoaded, webformGetLoaded } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/Webform';

const fromJSOrdered = (js) => {
  if (typeof js !== 'object' || js === null) {
    return js;
  }

  return Array.isArray(js) ?
    Immutable.Seq(js).map(fromJSOrdered).toList() :
    Immutable.Seq(js).map(fromJSOrdered).toOrderedMap();
};

export const webformGet = (webformId) => (
  (dispatch, getState) => {
    dispatch(referenceLoadingStart());

    const API_URL = config.get('WEBFORM_API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const credentials = getState().getIn(['ui', 'fetch', 'credentials', 'webform'])
      || getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
    const headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
    const init = { credentials, headers, mode: 'cors' };

    // Get webform info.
    fetch(`${PATH}/webform_rest/${webformId}/info?_format=json`, init)
      .then((response) => response.json())
      .then((data) => {
        dispatch(webformGetInfoLoaded(webformId, data));
      });

    // Get Webform fields.
    fetch(`${PATH}/webform_rest/${webformId}/fields?_format=json`, init)
      .then((response) => response.json())
      .then((json) => fromJSOrdered(json))
      .then((data) => {
        dispatch(webformGetLoaded(webformId, data));
        dispatch(referenceLoadingDone());
      })
      .catch(() => {
        dispatch(referenceLoadingDone());
      });
  }
);
